import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { PXFormModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import WizardStepDeleteButton from '../../DefaultFDWizardStep/Layout/WizardStepDeleteButton';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();

  async function handleDelete() {
    return resource.delete();
  }

  const onSuccess = async () => {
    clearModalCollection();
    refreshPageContentCollection();
  };

  return (
    <PXFormModalWrapper onSubmitSuccess={onSuccess}>
      <MetaLayoutRemainingFields noAccordion />
      {resource.meta().canDelete() ? (
        <WizardStepDeleteButton
          onDelete={handleDelete}
          onDeleteSuccess={onSuccess}
          dialogProps={{
            title: 'Are you sure?',
            message: 'Removing this entry will delete all of its information. This cannot be undone.',
            confirmLabel: 'Remove',
          }}
        />
      ) : null}
    </PXFormModalWrapper>
  );
};

export default Layout;
